export default "__VITE_ASSET__KyxWifD8__"